export default __webpack_public_path__ + "static/Entenda0148-b9c6b4214f445b25586c4fd7211b65e5.jpg";